import NextLink from "next/link";

import { Container, Flex, SimpleGrid, Text, VStack } from "@chakra-ui/react";

import CardCollection, {
  CardCollectionGridSkeleton,
} from "components/global/card-collection";

import { NftCollectionProps } from "utils/interface";
import { Collection } from "src/API";
import { EmptyItems } from "components/global/card-item";
import { useParameterStore } from "utils/context";

interface CollectionGridProps {
  collections: Array<NftCollectionProps>;
}

interface CollectionsProps {
  loaded?: boolean;
  collections?: Collection[];
}

export function CollectionGrid({ loaded, collections = [] }: CollectionsProps) {
  const { gridSize } = useParameterStore();

  return (
    <Container maxW={"container.2xl"}>
      <SimpleGrid
        overflow={"hidden"}
        columns={{
          base: gridSize == "medium" ? 1 : 1,
          sm: gridSize == "medium" ? 1 : 2,
          md: gridSize == "medium" ? 2 : 3,
          xl: gridSize == "medium" ? 3 : 4,
        }}
        spacing={8}
      >
        {collections.length > 0 &&
          collections.map((item, id) => (
            <CardCollection key={id} data={item} gridSize={gridSize} />
          ))}
        {!loaded &&
          [...Array(6)].map((i, x) => <CardCollectionGridSkeleton key={x} />)}
      </SimpleGrid>
      {collections.length == 0 && loaded && <EmptyItems />}
    </Container>
  );
}
